import { CSSProperties } from 'react';

export const Arrow = ({ fill = '#B3BAD1', style }: { fill?: string; style?: CSSProperties }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none" style={style}>
        <path
            d="M0.75 0.75L4.08333 4.08333L7.41667 0.75"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
